import {Component, Input, Optional} from '@angular/core';
import {TranslationService} from '@ngmedax/translation';
import {TRANSLATION_CRUD_SCOPE} from '../../../../../constants';
import {ConditionNode} from '../../workflow-condition';
import {ConditionVariable, conditionParts, ConditionPart} from './workflow-condition-model';

/** Highlights workflow sources while retaining full names and identifiers in tooltips. */
@Component({selector: 'app-workflow-condition-summary',
  template: '<ng-container *ngFor="let part of parts; trackBy: trackPart"><span [class.qa-source-chip]="part.kind === \'source\'" ' +
    '[class.qa-logic]="part.kind === \'logic\'" [attr.title]="part.title">{{part.text}}</span></ng-container>',
  styleUrls: ['./workflow-condition-summary.component.css']})
export class WorkflowConditionSummaryComponent {
  @Input() root: ConditionNode;
  @Input() variables: ConditionVariable[] = [];

  /** Injects the administration locale independently of questionnaire content. */
  public constructor(@Optional() private translation: TranslationService) {}

  /** Reuses chip nodes during nested draft edits. */
  public trackPart(index: number): number { return index; }

  /** Produces safe text fragments rather than interpolated HTML. */
  public get parts(): ConditionPart[] {
    return conditionParts(this.root, this.variables,
      text => this.translation ? this.translation.translate({text, scope: TRANSLATION_CRUD_SCOPE}) : text,
      token => this.translation ? this.translation.getDateFormat(token) : token);
  }
}
